import React from 'react';
import propTypes from 'prop-types';
import { Checkout } from './Checkout';
import { productPropTypes } from './productPropTypes';

const QuoteHeading = ({ vehicleInformation, product, product2 }) => (
  <>
    <div className="cmp-quote__title-cluster">
      <div>
        <h1 className="cmp-quote__title">My Quote</h1>
        <p className="util-margin-top-xxl">
          {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
        </p>
      </div>
      <Checkout product={product} product2={product2} />
    </div>
    <h2 className="cmp-quote__heading">
      {`For your ${vehicleInformation?.make ?? 'vehicle'} ${vehicleInformation?.model ?? ''}`}
    </h2>
  </>
);

QuoteHeading.propTypes = {
  vehicleInformation: propTypes.shape({
    splitFitment: propTypes.bool,
    year: propTypes.number,
    make: propTypes.string,
    model: propTypes.string,
    option: propTypes.string,
    tireWidth: propTypes.string,
    tireRimSize: propTypes.string,
    tireAspectRatio: propTypes.string,
    tireString: propTypes.string,
  }),
  product: productPropTypes,
  product2: productPropTypes,
};

export { QuoteHeading };
